import { Spin } from "antd";
import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";

export const CascadeRedirecting = () => {
    const { t } = usePaldockTranslation("ui.cascade");
    return (
        <div className="flex flex-col items-center gap-4 px-4 font-['Poppins',sans-serif]" role="status">
            <Spin size="large" className="[&_.ant-spin-dot-item]:!bg-[#34b86a]" />
            <p className="m-0 text-center text-base font-medium text-[#222]">{t("content.redirecting")}</p>
        </div>
    );
};
